// 9 Oct: whether this phone has a connection, as the browser sees it (navigator.onLine and the online and offline events).
// Offline is certain; online is only a guess (a captive portal or a dead cell still says online), so the senders still
// try and the server stays the judge. While offline the in-game screens show one line (components/OfflineBanner) and a
// tap on an answer is not sent at all: it is marked not sent and tried once by itself when the connection comes back.
import { useSyncExternalStore } from 'react';

export const isOnline = (): boolean => typeof navigator === 'undefined' || navigator.onLine !== false;

function subscribe(onChange: () => void): () => void {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => { window.removeEventListener('online', onChange); window.removeEventListener('offline', onChange); };
}

/** True while the browser believes it has a connection; re-renders on the online and offline events. */
export function useOnline(): boolean {
  return useSyncExternalStore(subscribe, isOnline, () => true);
}
